
import { PriceRange } from '../../types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class LowResultsPriceRange extends Vue {
  @Prop()
    priceRange: PriceRange

  get minPrice() {
    return {
      amount: (this.priceRange.min ? this.priceRange.min : 0) * 100,
      currency: 'GBP',
    }
  }

  get maxPrice() {
    return {
      amount: (this.priceRange.max ? this.priceRange.max : 0) * 100,
      currency: 'GBP',
    }
  }
}
